{
  "forms": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "add": "Ajouter",
    "update": "Mettre à jour",
    "edit": "Modifier",
    "delete": "Supprimer",
    "confirm": "Confirmer",
    "continue": "Continuer",
    "submit": "Soumettre",
    "create": "Créer",
    "search": "Rechercher",
    "search_placeholder": "Rechercher...",
    "select": "Sélectionner",
    "clear": "Effacer",
    "reset": "Réinitialiser",
    "apply": "Appliquer"
  },
  "nav": {
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "close": "Fermer",
    "open": "Ouvrir",
    "refresh": "Actualiser",
    "first_page": "première page",
    "previous_page": "page précédente",
    "next_page": "page suivante",
    "last_page": "dernière page"
  },
  "status": {
    "loading": "Chargement...",
    "saving": "Enregistrement...",
    "deleting": "Suppression...",
    "updating": "Mise à jour...",
    "processing": "Traitement...",
    "success": "Succès",
    "error": "Erreur",
    "warning": "Avertissement",
    "info": "Information",
    "not_found": "Introuvable",
    "items_selected": "Éléments sélectionnés"
  },
  "state": {
    "loading": "Chargement"
  },
  "actions": {
    "title": "Actions",
    "view": "Voir",
    "download": "Télécharger",
    "upload": "Téléverser",
    "import": "Importer",
    "export": "Exporter",
    "remove": "Supprimer",
    "share": "Partager",
    "archive": "Archiver",
    "show_more": "Afficher plus",
    "show_less": "Afficher moins",
    "show_all": "Tout afficher",
    "filters": {
      "title": "Filtres",
      "filter": "Filtre",
      "clear_filter": "Effacer le filtre",
      "remove_filter": "Supprimer le filtre",
      "more_filters": "Plus de filtres",
      "add_filter": "Ajouter un filtre",
      "is": "est",
      "one_of": "un de",
      "and": "et",
      "value_label": "Valeur",
      "value_placeholder": "Valeur",
      "operators": {
        "contains": "contient",
        "does_not_contain": "ne contient pas",
        "ends_with": "se termine par",
        "has_any_value": "a une valeur",
        "has_no_value": "n'a pas de valeur",
        "is": "est",
        "is_not": "n'est pas",
        "is_one_of": "est l'un de",
        "starts_with": "commence par",
        "unknown_operator": "opérateur inconnu"
      }
    },
    "restore": "Restaurer",
    "duplicate": "Dupliquer",
    "rename": "Renommer"
  },
  "confirmation": {
    "are_you_sure": "Êtes-vous sûr ?",
    "cannot_be_undone": "Cette action ne peut pas être annulée.",
    "confirm_delete": "Êtes-vous sûr de vouloir supprimer ceci ?",
    "confirm_archive": "Êtes-vous sûr de vouloir archiver ceci ?",
    "click_confirm": "Cliquez sur confirmer pour continuer",
    "click_confirm_to_delete": "Cliquez sur confirmer pour supprimer"
  },
  "errors": {
    "context_provider_required": "useZIndex doit être utilisé dans un ZIndexProvider"
  },
  "accessibility": {
    "info_tooltip": "Information {{label}}"
  },
  "icons": {
    "key_contact": "contact clé",
    "has_phone_number": "a un numéro de téléphone"
  },
  "priority": {
    "none": "aucune",
    "low": "faible",
    "medium": "moyenne",
    "high": "haute",
    "critical": "critique"
  }
}
